<template>
    <van-field
      v-model.trim="passwordValue"
      :maxlength="maxLength"
      autocomplete="off"
      :type="isShowPsw ? 'password' : 'text'"
      @click-right-icon="togglePasswordVisibility"
      :right-icon="isShowPsw ? closeIcon : openIcon"
      :placeholder="placeholder"
      @input="handleInput"
      class="password-input"
    />
  </template>
  
  <script>
  export default {
    name: 'PasswordInput',
    
    props: {
      // 密码值
      value: {
        type: String,
        default: ''
      },
      // 最大长度
      maxLength: {
        type: Number,
        default: 16
      },
      // 占位符文本
      placeholder: {
        type: String,
        default: '请输入密码'
      },
      // 闭眼图标
      closeIcon: {
        type: String,
        default: require('../assets/img/eyeClose.png')
      },
      // 开眼图标
      openIcon: {
        type: String,
        default: require('../assets/img/eyeOpen.png')
      }
    },
  
    data() {
      return {
        isShowPsw: true,
        passwordValue: this.value
      }
    },
  
    watch: {
      value(newVal) {
        this.passwordValue = newVal;
      }
    },
  
    methods: {
      // 切换密码显示/隐藏
      togglePasswordVisibility() {
        this.isShowPsw = !this.isShowPsw;
      },
  
      // 处理输入
      handleInput(value) {
        this.$emit('input', value);
        this.$emit('change', value);
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .password-input {
    :deep(.van-field__right-icon) {
      cursor: pointer;
      padding: 0 0.1rem;
      
      img {
        width: 0.32rem;
        height: 0.32rem;
      }
    }
  }
  </style>